/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

export const string = {
  SIGN_UP: "Signup",
  PLEASE_ENTER_YOUR_PHONE_NUMBER_TO_CONTINUE: "Enter your mobile number",
  VERIFICATION_CODE: "Verification code",
  WE_HAVE_SENT_A_CODE_TO: "We've sent you a verification code on this",
  WE_HAVE_SENT_A_CODE_TO_SMS: "We've sent you an SMS with the code on",
  WE_HAVE_SENT_A_CODE_TO_EMAIL: "We've sent you an email with the code on",
  MOBILE_NUMBER: "mobile number",
  ADDRESS: "address",
  VERIFY: "Verify",
  VERIFY_EMAIL: "Verify your email",
  RESEND_CODE: "Resend code",
  YOUR_DETAILS: "Your details",
  MORE_DETAILS: "more details",
  EMAIL_ALREADY_USED: "Email already in use",
  MOBILE_ALREADY_USED: "Mobile number already registered. Please sign in.",
  USE_DIFFERENT_EMAIL: "Please use a different email or contact support@myserviceactivator.com",
  ENTER_YOUR_PERSONAL_DETAILS_TO_PROCEED: "Enter your personal details",
  EMPLOYEE: "Employee",
  OWNER: "Owner",
  NEXT: "Next",
  BACK: "Back",
  FOR: "for",
  WORK_DETAILS: "Work details",
  SOMETHING_WENT_WRONG_TRY_LATER: "Something went wrong. Please try again later",
  SOMETHING_WENT_WRONG_TRY_AGAIN: "Something went wrong. Please try again",
  HOW_MANY_EMPLOYEES_HELPERS_DO_YOU_HAVE:
    "How many employees or helpers do you have?",
  ENTER_YOUR_OFFICE_ADDRESS_BELOW: "Enter your office address",
  ENTER_YOUR_COMPANY_DETAILS_BELOW: "Enter your company details",
  YOUR_COMPANY_DETAILS: "Your company details",
  HOW_FAR_ARE_YOU_WILLING_TO_TRAVEL:
    "How far are you willing to travel (in Mil.)?",
  PREFERRED_WORK_START_TIME: "Preferred work start time",
  HOW_MANY_SUBCONTRACTORS_DO_YOU_WORK_WITH:
    "How many sub-contractors do you work with?",
  HOW_MANY_VEHICLES_DO_YOU_HAVE: "How many vehicles do you have?",
  ADD_SKILLS: "Select skills",
  ADD_OR_SELECT_YOUR_SKILLS: "Enter custom skills or select from below",
  ADD: "Add",
  PROFILE_PICTURE: "Profile picture",
  YOUR_PROFILE_PICTURE_WILL_BE_VISIBLE_TO_YOUR_COWORKERS_AND_OTHER_COMMUNITY_MEMBERS_IT_CREATES_A_FRIENDLY_IMPRESSION:
    "Photo will be visible to your co-workers and other community members. It creates a friendly impression.",
  SELECT_PHOTO: "Select photo",
  EDIT_IMAGE: "Edit image",
  SKIP_FOR_NOW: "Skip for now",
  I_AM_AN: "I am an",
  INVALID_VERIFICATION_CODE: "Incorrect code",
  REQUIRED: "Required",
  NUMBER_MUST_BE_10_DIGIT: "Number must be 10 digit",
  ENTER_VALID_EMAIL: "Enter valid email",
  INVALID_ZIP_CODE: "Please enter a valid 5-digit ZIP code",
  BY_CLICKING_NEXT: "By clicking on 'Next', you agree to",
  TERMS_CONDITIONS: "ServiceActivator's T&C",
  ALREADY_HAVE_AN_ACCOUNT: "Already have an account? Sign in",
  WHAT_SKILL_DO_YOU_OFFER: "What skills do you offer?",
  ACTIVATING_YOUR_ACCOUNT: "Activating your account",
  PLEASE_WAIT: "Please wait...",
  WILL_TAKE_TIME: "It might take a couple of minutes for activation to complete",
  DO_NOT_REFRESH:"Do NOT refresh the page or navigate away from it",
  ACCOUNT_ACTIVATED: "Successfully Activated",
  CONGRATULATIONS: "Congratulations!",
  CHECK_YOUR: "Check your",
  EMAIL: "email",
  INBOX_FOR_CONFIRMATION_AND_MORE_DETAILS:
    "inbox for confirmation and more details.",
  INBOX_FOR_VERIFICATION_CODE:
    "inbox for verification code",
  CONFIRMATION_SMS: "We've sent you a confirmation SMS",
  CONFIRMATION_SMS_AND_EMAIL: "We've sent you a confirmation SMS and email",
  YOU_ARE_READY_TO: "You are ready to",
  LOGIN: "login",
  LOGINC: "Login",
  ON_SERVICEACTIVATOR: "on ServiceActivator.",
  APPLICATION_SUBMITTED: "Application Submitted",
  WE_HAVE_RECEIVED_YOUR_REQUEST_TO_JOIN_US:
    "We have received your request to join us.",
  WE_WILL_CONTACT_YOU_ONCE_WE_ARE_READY_TO_ONBOARD_YOU_WITH_US:
    "We will contact you once we are ready to on-board you with us.",
  EMAIL_VERIFIED: "Email Verified",
  YOUR_ACCOUNT_IS_NOW_FULLY_ACTIVATED_AND_ALL_FEATURES_ARE_ENABLED:
    "Your account is now fully activated and all features are enabled",
  ACTIVATION_FAILED: "Activation Failed",
  WE_WERE_UNABLE_TO_ACTIVATE_YOUR_ACCOUNT_DUE_TO_SOME_TECHNICAL_ISSUES:
    "We were unable to activate your account due to some technical issues.",
  OUR_SUPPORT_TEAM_HAS_BEEN_NOTIFIED_AND_WILL:
    "Our support team has been notified and will",
  REACH_OUT_TO_ASSIST_YOU_IN_THE_NEXT_24_HOURS:
    "reach out to assist you in the next 24 hours.",
  REQUEST_INVITATION: "Request Invitation",
  REQUEST_YOUR_COMPANYS_OWNER_OR_ADMINISTRATOR_TO_SEND_YOU_AN_INVITE_TO_JOIN_US:
    "Request your company's owner or administrator to send you an invite to join us",
  BACK_TO_HOME: "Back to home",

  // Placeholder strings
  FIRST_NAME: "First name",
  LAST_NAME: "Last name",
  EMAIL_ADDRESS: "Email address",
  REFERRAL_CODE: "Referral code (Optional)",
  PHONE_NUMBER: "Mobile number",
  ENTER_VERIFICATION_CODE: "Enter 6 digit verification code",
  STREET: "Street",
  ZIP_CODE: "Zip code",
  ENTER_NEW_SKILLS_OR_SELECT_FROM_BELOW:
    "Enter new skills or select from below",
  COMPANY_NAME: "Company name",
  SELECT_SKILLS: "Select skills",

  // Copyright strings
  COPYRIGHT_2016: "Copyright © 2016-",
  SERVICEACTIVATOR_INC_ALL_RIGHTS_RESERVED:
    "ServiceActivator Inc. All rights reserved.",
  IN_CASE_OF_ANY_ISSUES_PLEASE_REACH_OUT_TO_US_ON_BELOW_EMAIL:
    "In case of any issues, please reach out to us on below email",
  HELPMYSERVICEACTIVATORCOM: "support@myserviceactivator.com",
};
